import {getCookie} from '@common/utils/cookies';

export function isCypressEnv() {
  return getCookie('env') === 'cypress';
}
